import { SimulationStartDate } from 'Input/SimulationStartDate';
import { SimulationEndDate } from 'Input/SimulationEndDate';
import { Typography, Stack } from '@mui/material';

const DateSimulation = () => {
  return (
    <Stack spacing={1}>
          
      <Typography variant='body1' component='h1' textAlign='center'>
      Select the time period for calculating slurry methane emissions.
      </Typography>
    <>
      <SimulationStartDate/>
      <SimulationEndDate/>
    </>
  </Stack>);
}

export default DateSimulation;
